module.exports = __webpack_public_path__ + "static/media/H19.993abaa9.png";